<template>
  <div
    class="hover-video"
    @mouseenter.self="onMouseenter"
    @mouseleave.self="onMouseleave"
  >
    <div class="content">
      <slot name="cover"></slot>
      <Resource
        v-if="!data?.cover_url"
        :src="DEFAULT_COVER"
        class="w-full object-cover"
        :transform-resource="transformImage"
      />
      <Resource
        v-else
        :src="data?.cover_url"
        :alt="data.name"
        :class="
          data.resolution === '1080x1920' ? 'object-contain' : 'object-cover'
        "
        :title="data.name"
        :transform-resource="transformImage"
        class="w-full"
      />
      <video
        v-if="showVideo"
        :src="showVideo ? data?.hover_video || data?.preview_video : ''"
        autoplay
        loop
        muted
        playsinline
        :class="[
          'w-full',
          'h-full',
          data?.resolution === '1080x1920' ? 'object-contain' : 'object-cover',
        ]"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{
  data: {
    cover_url?: string
    resolution?: string
    hover_video: string
    preview_video?: string
    name?: string
  }
}>()

const DEFAULT_COVER = getFeUrl('/youyan-platform/png/cover-default.png')

const showVideo = ref(false)
const mouseover = ref(false)
let timer: any = null

const onMouseenter = () => {
  mouseover.value = true
  timer = setTimeout(() => {
    showVideo.value = true
  }, 300)
}

const onMouseleave = () => {
  showVideo.value = false
  mouseover.value = false
  clearTimeout(timer)
  timer = null
}
</script>

<style lang="scss" scoped>
.hover-video {
  @apply w-full h-full relative rounded-[10px] outline-0 overflow-hidden flex flex-col box-content;
  .content {
    @apply relative bg-back-4 overflow-hidden cursor-pointer flex-1;
    width: 100%;
    border-bottom: 0;
    border-radius: 10px;
    img,
    video {
      @apply absolute w-full h-full top-0 left-0;
      transition: transform 0.3s ease;
    }
  }
  &:hover {
    .content img,
    .content video {
      transform: scale(1.05);
    }
  }
}
</style>
